const DraggableComponentEvent = {
    DRAG_BEGIN: "DragBegin",
    DRAG_END: "DragEnd",
    DRAG_UPDATE: "DragUpdate",
    TARGET_ENTER: "TargetEnter",
    TARGET_EXIT: "TargetExit"
};

export default DraggableComponentEvent;